export default __webpack_public_path__ + "static/ABA_2020-Finalist_Newcomer of the Year-0e8debeabada9b2e92d04348985fecdc.png";